"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const webview_app_1 = require("@/webview_app");
const info_icon_black_svg_1 = __importDefault(require("@@/assets/svgs/info_icon_black.svg"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const Dialog_1 = __importDefault(require("@mui/material/Dialog"));
const styled_1 = __importDefault(require("@emotion/styled"));
function default_1({ detail }) {
    const [open, setOpen] = (0, react_1.useState)(false);
    const closeDialog = () => setOpen(false);
    (0, webview_app_1.useAABBDialogClose)({ open, closeDialog });
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ onClick: () => setOpen(true) }, { children: (0, jsx_runtime_1.jsx)(info_icon_black_svg_1.default, { css: { path: { fillOpacity: 0.3 } } }) })), (0, jsx_runtime_1.jsx)(DetailDialog, Object.assign({ open: open, onClose: closeDialog }, { children: detail }))] }));
}
exports.default = default_1;
const DetailDialog = (0, styled_1.default)(Dialog_1.default) `
  .MuiDialog-paper {
    width: 80%;
    max-width: 480px;
    padding: 16px;
    border-radius: 8px;
    margin: 0;
  }
  h1 {
    margin-bottom: 8px;
    font-weight: 700;
    font-size: 17px;
  }
  p,
  li {
    margin-bottom: 0;
    color: #90a1b8;
    font-size: 16px;
    line-height: 22px;
    word-break: break-all;
  }
  ul {
    margin: 0;
    padding-left: 20px;
  }
`;
